<template>
  <el-dialog :title="formTitleMap[addressForm.action]" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="addressForm" :rules="addressRules" :model="addressForm" label-width="90px" size="small" class="address-form">
      <!-- <el-form-item label="地址名称" prop="shortAddress">
        <el-input v-model="addressForm.shortAddress" />
      </el-form-item> -->
      <el-form-item label="联系人" prop="contactPerson">
        <el-input v-model="addressForm.contactPerson"/>
      </el-form-item>
      <el-form-item label="联系手机" prop="contactMobile">
        <el-input v-model="addressForm.contactMobile" class="middle-item" maxlength="11" />
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="addressForm.contactPhone" class="middle-item"/>
      </el-form-item>
      <el-form-item label="地区" prop="areaData">
        <AreaSelector v-model="addressForm.areaData" />
      </el-form-item>
      <el-form-item label="详细地址" prop="detailAddress">
        <el-input v-model="addressForm.detailAddress"/>
      </el-form-item>
      <!-- <el-form-item label="邮编" prop="zipCode">
        <el-input v-model="addressForm.zipCode" class="short-item"/>
      </el-form-item>
      <el-form-item label="传真" prop="faxNumber">
        <el-input v-model="addressForm.faxNumber" class="middle-item"/>
      </el-form-item> -->
      <el-form-item label="默认地址" prop="isDefault">
        <el-checkbox v-model="addressForm.isDefault" :true-label="1" :false-label="0" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="loading" type="primary" class="btn-red" @click="submitForm">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
import formValidators from '@/utils/formValidators'
import AreaSelector from '@/components/area-selector'
export default {
  name: 'AddressForm',
  components: {
    AreaSelector
  },
  data() {
    return {
      addressForm: {
        action: '',
        addressId: '',
        shortAddress: '',
        contactPerson: '',
        contactMobile: '',
        contactPhone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detailAddress: '',
        isDefault: 0,
        zipCode: '',
        faxNumber: '',
        areaData:{
          provinceId: '',
          cityId: '',
          countyId: ''
        }
      },
      addressRules: {
        // shortAddress: [{ required: true, message: '请输入收货地址名称', trigger: 'change' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'change' }],
        contactMobile: [
          { required: true, message: '请输入联系手机', trigger: 'change' },
          { validator: formValidators.checkMobile, trigger: 'change' }
        ],
        areaData: [
          { required: true, message: '请设置地区信息', trigger: 'change' },
          { validator: formValidators.validateAreaData, trigger: 'change' }
        ],
        detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'change' }]
      },
      dialogVisible: false,
      formTitleMap: {
        update: '修改收货地址',
        create: '新建收货地址'
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    // eslint-disable-next-line
    show(obj, option) {
      this.resetForm()
      if (obj) {
        this.addressForm = Object.assign(this.addressForm, obj)
      }
      this.addressForm.areaData = {
        provinceId: this.addressForm.provinceId,
        cityId: this.addressForm.cityId,
        countyId: this.addressForm.countyId
      }
      this.option = obj.option || null
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['addressForm'].clearValidate()
      })
    },
    resetForm() {
      this.addressForm = {
        action: '',
        addressId: '',
        shortAddress: '',
        contactPerson: '',
        contactMobile: '',
        contactPhone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detailAddress: '',
        isDefault: 0,
        zipCode: '',
        faxNumber: '',
        areaData:{
          provinceId: '',
          cityId: '',
          countyId: ''
        }
      }
    },
    submitForm() {
      this.$refs['addressForm'].validate((valid) => {
        if (valid) {
          this.addressForm.provinceId = this.addressForm.areaData.provinceId
          this.addressForm.cityId = this.addressForm.areaData.cityId
          this.addressForm.countyId = this.addressForm.areaData.countyId
          if (this.addressForm.action === 'create') {
            this.submitCreate()
          }
          if (this.addressForm.action === 'update') {
            this.submitUpdate()
          }
        }
      })
    },
    submitCreate() {
      this.loading = true
      userApi.addAddress(this.addressForm).then(response => {
        this.loading = false
        if (response.data.resultCode === '0') {
          this.$emit('success')
          this.dialogVisible = false
          this.$message.success('收货地址创建成功')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitUpdate() {
      this.loading = true
      userApi.updateAddress(this.addressForm).then(response => {
        this.loading = false
        if (response.data.resultCode === '0') {
          this.$emit('success')
          this.dialogVisible = false
          this.$message.success('收货地址更新成功')
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>
.address-form {
  width: 90%;
}
</style>
